module.exports = __webpack_public_path__ + "img/Natsambi-Raymond.93de3027.jpg";